module.exports = __webpack_public_path__ + "img/arrow-right-small.4e9b3619.svg";